import { MODAL_Z_INDEX } from '../modal/modal.style';
import { DefaultTheme } from '../theme';

export const CSS = {
	menu: 'c-Menu',
	isOpen: 'c-Menu--Open',
	isClosed: 'c-Menu--Close',
	isClosing: 'c-Menu--Closing',
	isOpening: 'c-Menu--Opening',
	divider: 'c-Menu__Divider',
	item: {
		container: 'c-Menu__Item',
		isSelected: 'c-Menu__Item--Selected',
	},
};

export const Style = {
	[CSS.menu]: {
		position: 'absolute',
		top: '100%',
		right: 0,
		'min-width': '200px',
		padding: `${DefaultTheme.space(1)} 0`,
		'z-index': MODAL_Z_INDEX + 1,
		color: DefaultTheme.font.color.supporting,
		'background-color': DefaultTheme.background.offWhite,
		display: 'flex',
		'flex-direction': 'column',
		'border-radius': '8px',
		'box-shadow': DefaultTheme.shadow.box.dp4,
		opacity: 1,
		transform: 'translateY(0)',
		'transform-origin': 'top right',
		transition: 'opacity .15s ease-in-out, transform .15s ease-in-out',
	},
	[CSS.divider]: {
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		margin: `0 ${DefaultTheme.space(1)}`,
	},
	[CSS.isClosed]: {
		display: 'none',
	},
	[CSS.isOpening]: {
		opacity: '0',
		transform: 'translateY(-4px) scale(0.98)',
	},
	[CSS.isClosing]: {
		opacity: '0',
		transform: 'translateY(-4px) scale(0.98)',
		'pointer-events': 'none',
	},
};
